import NAMES from '~/constants/NAMES';

export const clearToken = (): void => {
  sessionStorage.removeItem(NAMES.TOKEN);
};

export default clearToken;
